import React from 'react'
import { StateProvider } from '../state'
import { Quiz } from './Quiz'
import { QuizHeader } from './QuizHeader'
import { CardFilter } from './CardFilter'

export const FlashcardApp = ({ flashcards, chapters }) => {
  const initialState = {
    flashcards: flashcards,
    chapters: chapters,
    filteredCards: flashcards,
    currentCardIndex: 0,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateCards':
        return {
          ...state,
          filteredCards: action.payload,
          currentCardIndex: 0,
        }
      case 'updateCardIdx':
        return {
          ...state,
          currentCardIndex: action.payload,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <CardFilter />
      <QuizHeader />
      <Quiz />
    </StateProvider>
  )
}
